export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-14">
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden bg-background-800">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20minimal%20mobile%20app%20interface%20mockup%20on%20phone%20screen%2C%20golden%20amber%20cinematic%20theme%2C%20clean%20modern%20design%2C%20soft%20warm%20lighting%2C%20elegant%20composition%2C%20no%20text&width=400&height=400&seq=app-6080-qr&orientation=squarish"
                alt="6080新视觉影视移动端 - 手机观影"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="text-center md:text-left flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-background-800 text-background-300 text-xs font-medium mb-3">
              移动观影
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
              随时随地 · 畅享高清
            </h2>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              手机浏览器直接访问，无需下载安装。响应式设计自适应屏幕尺寸，支持手势控制亮度音量，
              横竖屏自由切换，通勤路上、睡前时光，随时随地享受超清画质影视。
            </p>

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mt-5">
              <div className="flex items-center gap-2">
                <i className="ri-smartphone-line text-accent-400"></i>
                <span className="text-xs text-background-400">全机型适配</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-wifi-line text-accent-400"></i>
                <span className="text-xs text-background-400">智能省流量</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-fullscreen-line text-accent-400"></i>
                <span className="text-xs text-background-400">横竖屏切换</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}